// removed by extract-text-webpack-plugin
module.exports = {"Card":"CountryListStyle__Card__3p9m5","CountryName":"CountryListStyle__CountryName__3lAB3","LoadingContainer":"CountryListStyle__LoadingContainer__3ix_r","CardImg":"CountryListStyle__CardImg__NE3nh"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/StoreList/CountryListStyle.css
// module id = 160
// module chunks = 0